import React, { useState } from 'react';
import { Form, Alert } from 'react-bootstrap';
import moment from 'moment';

const AttestatiManager = ({ utente, esami, onEsameSelect }) => {
  const [selectedEsame, setSelectedEsame] = useState('');

  const handleEsameSelection = (e) => {
    const value = e.target.value;
    setSelectedEsame(value);
    onEsameSelect(value);
  };

  const renderEsameOption = (esame) => {
    const data = moment(esame.esame.data).format('DD/MM/YYYY');
    const oraInizio = moment(esame.esame.ora_inizio, 'HH:mm:ss').format('HH:mm');
    const oraFine = moment(esame.esame.ora_fine, 'HH:mm:ss').format('HH:mm');
    
    return `Esame del ${data} (${oraInizio}-${oraFine}) - ${esame.esito_esame.toUpperCase().replace('_', ' ')}`;
  };

  const getEsitoClass = (esito) => {
    switch(esito.toLowerCase()) {
      case 'promosso':
        return 'text-success';
      case 'non_svolto':
        return 'text-warning';
      case 'bocciato':
        return 'text-danger';
      default:
        return '';
    }
  };

  return (

    <div className="container">
      {/* Selezione Esame */}
        <div>
          <h5 className="card-title mb-3">Seleziona Esame</h5>
          {esami?.length > 0 ? (
            <>
            <div className="card mb-4">
              <div className="card-body">
                <h5 className="card-title mb-3">Dati Utente</h5>
                <div className="row">
                  <div className="col-md-6">
                    <p className="mb-1"><strong>Nome:</strong> {utente?.nome}</p>
                    <p className="mb-1"><strong>Cognome:</strong> {utente?.cognome}</p>
                    <p className="mb-1"><strong>Email:</strong> {utente?.email}</p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1"><strong>Luogo di nascita:</strong> {utente?.luogo_nascita}</p>
                    <p className="mb-1">
                      <strong>Data di nascita:</strong> {moment(utente?.data_nascita).format('DD/MM/YYYY')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
              <Form.Group>
                <Form.Select 
                  value={selectedEsame} 
                  onChange={handleEsameSelection}
                  className="mb-3"
                >
                  <option value="">Seleziona un esame...</option>
                  {esami?.map((esame) => (
                    <option 
                      key={esame.id_calendario_esame_utente} 
                      value={esame.id_calendario_esame_utente}
                      disabled={esame.esito_esame !== 'promosso'}
                    >
                      {renderEsameOption(esame)}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* Dettagli Esame Selezionato */}
              {selectedEsame && (
                <div className="mt-3">
                  {esami?.filter(esame => esame.id_calendario_esame_utente.toString() === selectedEsame).map(esame => (
                    <div key={esame.id_calendario_esame_utente} className="border rounded p-3">
                      <h6>Dettagli Esame</h6>
                      <p className="mb-1">
                        <strong>Data:</strong> {moment(esame.esame.data).format('DD/MM/YYYY')}
                      </p>
                      <p className="mb-1">
                        <strong>Orario:</strong> {moment(esame.esame.ora_inizio, 'HH:mm:ss').format('HH:mm')} - {moment(esame.esame.ora_fine, 'HH:mm:ss').format('HH:mm')}
                      </p>
                      <p className="mb-1">
                        <strong>Esito:</strong> <span className={getEsitoClass(esame.esito_esame)}>{esame.esito_esame.toUpperCase()}</span>
                      </p>
                      {esame.voto && (
                        <p className="mb-1"><strong>Voto:</strong> {esame.voto}</p>
                      )}
                      {esame.note && (
                        <p className="mb-1"><strong>Note:</strong> {esame.note}</p>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <Alert variant="primary">
              Nessun esame disponibile per questo utente.
            </Alert>
          )}
        </div>
      </div>
  );
};

export default AttestatiManager;
